import React from "react";
import Overlay from "../Overlay";
import SamplesAPI from "../../network/SamplesAPI";
import AdminAPI from "../../network/AdminAPI";
import { AuthContext } from "../../context/AuthContext";
import { getIdToken } from "firebase/auth";
import { UserContext } from "../../types/UserContext";
import { sweetalert } from "../../App";

interface AdminHomePageState {
  showLoading?: boolean;
  facilitySamplesArray
  facilities
  userProfile?: UserContext
}

export default class AdminHomePage extends React.Component<
  any,
  AdminHomePageState
> {

  static contextType = AuthContext;
  context!: React.ContextType<typeof AuthContext>;

  constructor(props) {
    super(props);
    this.state = {
      showLoading: false,
      facilitySamplesArray: [],
      facilities: [],
      userProfile: null,
    };
  }

  // componentDidMount(): void {
  //   document.title = 'Admin Home Page';
  //   document.body.style.backgroundImage = ``;
  //   document.body.style.backgroundColor = '#FFFFFF'
  //   this.setState({ showLoading: true }, async () => {
  //     AdminAPI.getFacilitiesForSubmissionForm().then(data => {
  //       this.setState({facilities: data.authorizedFacilities})
  //     })
  //     SamplesAPI.getAllSamplesForAdminHome().then(data => {
  //       this.setState({
  //         facilitySamplesArray: data.facilitySamplesArray,
  //         showLoading: false,
  //       });
  //     })
      
  //   });
  // }

  componentDidMount(): void {
    document.title = 'Admin Home Page';
    document.body.style.backgroundImage = ``;
    document.body.style.backgroundColor = '#FFFFFF'
    this.setState({ showLoading: true }, async () => {
      try {
        // Get user profile including FacilityIDs
        let idToken = await getIdToken(this.context, true);
        const userCredential = await AdminAPI.getAuthenticated({ token: idToken });
        let userProfile: UserContext = userCredential.user;


        // Parse user's FacilityIDs
        let userFacilityIDs = [];
        if (userProfile.FacilityIDs) {
          try {
            userFacilityIDs = JSON.parse(userProfile.FacilityIDs);
          } catch (e) {
            console.error('Error parsing FacilityIDs', e);
          }
        } else {
          console.log('No FacilityIDs found on user profile');
        }


        AdminAPI.getFacilitiesForSubmissionForm().then(data => {
          let facilities = data.authorizedFacilities;

          this.setState({facilities: facilities})
          if(userFacilityIDs.length > 0){
            facilities = facilities.filter(f => userFacilityIDs.includes(f.ID));
          }

          if(facilities.length > 0){
            // Check for TOC acceptance and Provider Network opt-in
            let tocNotAcceptedFacilities = facilities.filter(f => !f.TOC_Accepted);
            let providerNetworkNullFacilities = facilities.filter(f => f.InProviderNetwork === null);

            if(tocNotAcceptedFacilities.length > 0 || providerNetworkNullFacilities.length > 0){
              this.setState({showLoading: false});

              let needsTOC = tocNotAcceptedFacilities.length > 0;
              let needsProviderNetwork = providerNetworkNullFacilities.length > 0;

              let contentHTML = `
                <div style="text-align: center; max-height: 500px; overflow-y: auto; padding: 1rem;">
                  <div style="margin-bottom: 1.5rem; padding: 1rem; border: 1px solid #ddd; border-radius: 4px;">
                    <h5>Terms of Service</h5>
                    <p style="font-size: 1rem;">Please review the <a href="https://orapath.com/policies/terms-of-service" target="_blank" rel="noopener noreferrer">Terms of Service</a></p>
                    ${needsTOC ? `
                      <div style="margin-top: 1rem; display: flex; justify-content: center;">
                        <label style="display: flex; align-items: center; cursor: pointer;">
                          <input type="checkbox" id="toc-checkbox" style="margin-right: 10px; width: 18px; height: 18px;">
                          <span style="font-size: 1rem;">I accept the Terms of Service</span>
                        </label>
                      </div>
                    ` : '<p style="color: green; font-size: 1rem;">✓ Terms of Service already accepted</p>'}
                  </div>

                  <div style="margin-bottom: 1.5rem; padding: 1rem; border: 1px solid #ddd; border-radius: 4px;">
                    <h5>Provider Network</h5>
                    <p style="font-size: 1rem;">
                      Your organization's information will be published in OraPath's Provider Network. This helps improve access to comprehensive oral medicine for patients who don't currently have a primary dental provider.
                    </p>
                    ${needsProviderNetwork ? `
                      <div style="margin-top: 1rem; display: flex; justify-content: center;">
                        <label style="display: flex; align-items: center; cursor: pointer;">
                          <input type="checkbox" id="provider-network-checkbox" style="margin-right: 10px; width: 18px; height: 18px;">
                          <span style="font-size: 1rem;">I want to opt-in to the Provider Network</span>
                        </label>
                      </div>
                    ` : '<p style="color: green; font-size: 1rem;">✓ Provider Network decision already made</p>'}
                  </div>
                </div>
              `;

              setTimeout(() => {
                sweetalert.fire({
                  title: 'Action Required',
                  html: contentHTML,
                  icon: 'warning',
                  showCancelButton: false,
                  confirmButtonText: 'Save',
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  width: '600px',
                  preConfirm: () => {
                    let tocChecked = needsTOC ? (document.getElementById('toc-checkbox') as HTMLInputElement)?.checked : true;
                    let providerNetworkChecked = needsProviderNetwork ? (document.getElementById('provider-network-checkbox') as HTMLInputElement)?.checked : false;

                    if(needsTOC && !tocChecked){
                      sweetalert.showValidationMessage('You must accept the Terms of Service to continue');
                      return false;
                    }

                    return { tocChecked, providerNetworkChecked };
                  }
                }).then((result) => {
                  if (result.isConfirmed && result.value) {
                    let promises = [];

                    if(needsTOC && result.value.tocChecked){
                      promises.push(AdminAPI.acceptTOC(tocNotAcceptedFacilities.map(f => f.ID)));
                    }

                    if(needsProviderNetwork){
                      promises.push(AdminAPI.optInProviderNetwork(providerNetworkNullFacilities.map(f => f.ID), result.value.providerNetworkChecked));
                    }

                    if(promises.length > 0){
                      Promise.all(promises).then((results) => {
                        let allSuccess = results.every(r => r.success);
                        if(allSuccess){
                          let message = [];
                          if(needsTOC) message.push('Terms of Service accepted.');
                          if(needsProviderNetwork) {
                            message.push(result.value.providerNetworkChecked ? 'Opted into Provider Network.' : 'Declined Provider Network.');
                          }

                          sweetalert.fire({
                            icon: 'success',
                            title: 'Success',
                            html: message.join('<br>')
                          });
                        } else {
                          let failedReasons = results.filter(r => !r.success).map(r => r.reason).join(', ');
                          sweetalert.fire({
                            icon: 'error',
                            title: 'Failed',
                            text: failedReasons
                          });
                        }
                      });
                    }
                  }
                });
              }, 3000);
            }
          }

          
        })
        SamplesAPI.getAllSamplesForAdminHome().then(data => {
          this.setState({
            facilitySamplesArray: data.facilitySamplesArray,
            showLoading: false,
          });
        })

      } catch (e) {
        console.error('Error loading admin home page:', e);
        sweetalert.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to load admin home page. Check console for details.'
        });
        this.setState({ showLoading: false });
      }
    });
  }


  getCard(title, number, samples){
    if(title === 'Submitted'){
      return (
        <div className="col-12 col-md-4" 
          onClick={() => {
            window.location.href = `/admin/Samples?f=${samples.FacilityID}&p=0&c=0`
          }}>
          <div className="card mt-2 text-center font-weight-bold">
            <div className="card-header verlag-bold">
              <h4>{title}</h4>
            </div>
            <div className="card-body hover-card" style={{fontSize: '3rem'}}>
              {number || number === 0 ? number : 'N/A'}
            </div>
          </div>
        </div>
      )
    }
    else if(title === 'Processing'){
      return(
        <div className="col-12 col-md-4" 
          onClick={() => {
            window.location.href = `/admin/Samples?f=${samples.FacilityID}&p=1&c=0`
          }}>
          <div className="card mt-2 text-center font-weight-bold">
            <div className="card-header verlag-bold">
              <h4>{title}</h4>
            </div>
            <div className="card-body hover-card" style={{fontSize: '3rem'}}>
              {number || number === 0 ? number : 'N/A'}
            </div>
          </div>
        </div>
      )
    }
    else if(title === 'Completed'){
      return(
        <div className="col-12 col-md-4" 
          onClick={() => {
            window.location.href = `/admin/Samples?f=${samples.FacilityID}&p=0&c=1`
          }}>
          <div className="card mt-2 text-center font-weight-bold">
            <div className="card-header verlag-bold">
              <h4>{title}</h4>
            </div>
            <div className="card-body hover-card" style={{fontSize: '3rem'}}>
              {number || number === 0 ? number : 'N/A'}
            </div>
          </div>
        </div>
      )
    }
  }


  render():
    | React.ReactElement
    | string
    | number
    | {}
    | React.ReactNodeArray
    | React.ReactPortal
    | boolean
    | null
    | undefined {

      // console.log('AdminHomePage state', this.state)

    return (
      <React.Fragment>
        <Overlay show_loading={this.state.showLoading} />
        <main id="main-content" tabIndex={-1} aria-label="Home Page Samples Statistics">
          <div className="container-fluid">
              <div className={"row"}>
                <div className="col-12 pt-2">
                  {this.state.facilitySamplesArray && this.state.facilitySamplesArray.length > 0 ? this.state.facilitySamplesArray.map((f, index) => {
                    return (
                    <article>
                    <div className={index > 0 ? "card mt-5" : "card mt-2"}>
                      <div className="card-header verlag-bold">
                        <div className="row">
                          <div className="col-12 text-center">
                            <h4>Samples Stats for {this.state.facilities && this.state.facilities.length > 0 ? this.state.facilities.find(fa => fa.ID === f.FacilityID)?.FacilityName : ''}</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      {this.getCard('Submitted', f.Submitted, f)}
                      {this.getCard('Processing', f.Processing, f)}
                      {this.getCard('Completed', f.Completed, f)}
                    </div>
                    </article>
                    )
                  }
                    ) : (
                    <div className="col-12 pt-2">
                      <div className="card mt-2">
                        <div className="card-header verlag-bold">
                          <div className="row">
                            <div className="col-12 text-center">
                              <h5>No sample stats to show</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    )
                  }
                </div>
              </div>
          </div>
        </main>
      </React.Fragment>
    );
  }
}
